import React, { useState, useEffect, createContext, useRef } from "react";
import Modal from "react-bootstrap/Modal";
import "./Shareresume.scss";
import { useParams, withRouter } from "react-router-dom";
import { selectAllText } from "../../Utils/Common";

import {
  FacebookShareButton,
  LinkedinShareButton,
  EmailShareButton,
} from "react-share";
import { FacebookShareCount } from "react-share";
import { FacebookIcon, LinkedinIcon, EmailIcon } from "react-share";

function Shareresume(props) {
  const inputRef = useRef();
  const baseurl = process.env.REACT_APP_SHARE_URL;
  const { id } = useParams();
  const [url, setUrl] = useState("");
  const [shareText, setShareText] = useState("Copy Link");

  const [resumeId, setResumeId] = useState("");
  const [active, setActive] = useState(false);

  useEffect(() => {
    setResumeId(props.resumeId);
    setShareText("Copy Link");
    setActive(false);
  }, [props]);

  const handleInputEditable = () => {
    inputRef.current.select();
  };

  const shareClick = () => {
    handleInputEditable();
    setShareText("Copied");
    navigator.clipboard.writeText(url);
    setActive(true);
  };

  useEffect(() => {
    setUrl(
      `${baseurl}/${props && props.cover == "cover" ?"qrcover" :"qr"}/${resumeId}`
    );
  }, [resumeId]);

  const handleFocus = (event) => {
    selectAllText(event);
  };

  return (
    <>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        keyboard={true}
        onHide={props.shareHide}
        onEscapeKeyDown={props.shareHide}
      >
        <Modal.Body>
          {/* <button type="button" className="close" onClick={props.shareHide}>
            <span aria-hidden="true">
              <img src="/images/close.svg" alt="closeicon" className="close" />
            </span>
            <span className="sr-only">Close</span>
          </button> */}
          <img
            onClick={props.shareHide}
            src={`${process.env.REACT_APP_COMMON_ASSET_PATH}/close.svg`}
            alt="closeicon"
            className="close"
          />
          <div className="container">
            <div className="text-center">
              <h4 className="maintitle sharetitle">
                Share a Link to Your{" "}
                {props && props.cover == "cover" ? " Cover Letter" : " Resume"}
              </h4>
              <p className="titledesc mt-2 sharedesc">
                Share this link on social media or copy and paste the URL to
                send your {props && props.cover ? " cover Letter" : " resume"}{" "}
                via text, email or to share your{" "}
                {props && props.cover == "cover" ? " cover Letter" : " resume"}{" "}
                on your personal website.
              </p>
              <div className="sharebody mb-3">
                <label>Share URL</label>
                <div className="row ">
                  <div className="col-md-9 col-sm-12 col-12">
                    <input
                      ref={inputRef}
                      value={url}
                      type="text"
                      className="form-control customform shareinput mb-3 lg-mb-0"
                      onClick={shareClick}
                      onFocus={handleFocus}
                    />
                  </div>
                  <div className="col-md-3 col-sm-12 col-12">
                    <button
                      onClick={shareClick}
                      className={
                        active
                          ? "btn active_share_btn w-100 sharebtn"
                          : "btn successbtn w-100 sharebtn"
                      }
                    >
                      {shareText}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="text-center">
              <p className="titledesc sharecontent">
                or share on your social media platforms
              </p>
            </div>
            <div className="row">
              <div className="col-md-4 col-sm-12 col-12">
                <EmailShareButton
                  url={url}
                  quote="quote"
                  className=" btn customform sharebtns w-100 mb-3 mt-3"
                >
                  <i class="fa fa-envelope-o loginlogos" aria-hidden="true"></i>
                  Email
                </EmailShareButton>
              </div>
              <div className="col-md-4 col-sm-12 col-12">
                <FacebookShareButton
                  url={url}
                  quote="quote"
                  className=" btn customform sharebtns w-100 mb-3 mt-3"
                >
                  <i class="fa fa-facebook loginlogos" aria-hidden="true"></i>
                  Facebook
                </FacebookShareButton>
              </div>
              <div className="col-md-4 col-sm-12 col-12">
                <LinkedinShareButton
                  url={url}
                  quote="quote"
                  className=" btn customform sharebtns w-100 mb-3 mt-3"
                >
                  <i class="fa fa-linkedin loginlogos" aria-hidden="true"></i>
                  LinkedIn
                </LinkedinShareButton>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default Shareresume;
